import CrazyGamesHostIntegration from "./CrazyGamesHostIntegration";
import HostConfig from "./HostConfig";
import NoopHostIntegration from "./NoopHostIntegration";
import type { HostIntegration } from "./types";

const hostIntegration: HostIntegration = HostConfig.host === "crazygames"
    ? new CrazyGamesHostIntegration()
    : new NoopHostIntegration();

export type {
    AudioMuteHandler,
    HostGameStatus,
    HostIntegration,
    HostRoom,
    PlayerAuthenticationHandler,
    PlayerAuthenticationResult,
    RoomJoinHandler,
    RoomLaunchIntent,
} from "./types";

export default hostIntegration;
